module.exports = __webpack_public_path__ + "manageStatic/img/logo.bdfd449c.png";